import { useId } from "react"

/**
 * MMIPractice lockup, inlined so the wordmark renders in the site's own
 * Inter - next/font registers the family under a private name, so
 * var(--font-sans) is the only reliable way for SVG text to use it. An
 * <img>-loaded SVG can't reach page fonts at all and would fall back to
 * system sans. For raster surfaces (email, OG), use the baked PNG lockups
 * in /public (mmipractice-lockup*.png).
 *
 * Variants match the brand kit: default (gradient tile + two-tone wordmark),
 * gray (subdued monochrome, e.g. checkout), dark (for dark backgrounds).
 */
export function Logo({ variant = "default", className }) {
  const uid = useId()
  const g = `${uid}-g`
  const tg = `${uid}-tg`
  const gray = variant === "gray"
  const dark = variant === "dark"

  const tileFill = gray ? "#9f9fa9" : `url(#${g})`
  const inkFill = gray ? "#71717b" : dark ? "white" : "#09090b"
  const practiceFill = gray ? "#71717b" : `url(#${tg})`
  const orgFill = dark || gray ? "#71717b" : "#9f9fa9"

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 10 700 100"
      className={className}
      style={{ fontFamily: "var(--font-sans), Inter, ui-sans-serif, system-ui, sans-serif" }}
      aria-label="MMIPractice.org"
      role="img"
    >
      {!gray && (
        <defs>
          <linearGradient id={g} x1="15%" y1="100%" x2="80%" y2="0%">
            <stop offset="0" stopColor="#519500" />
            <stop offset="1" stopColor="#3fe240" />
          </linearGradient>
          <linearGradient id={tg} x1="0" y1="0" x2="1" y2="0.18">
            <stop offset="0" stopColor="#2cc544" />
            <stop offset="1" stopColor="#4f8c00" />
          </linearGradient>
        </defs>
      )}
      <g transform="translate(0,10)">
        <rect width="100" height="100" rx="26" fill={tileFill} />
        <g transform="translate(14,14) scale(0.72)">
          <path
            d="M50 37 C44 27 30 25 21 35 C12 45 12 64 22 77 C29 87 40 92 50 87 C60 92 71 87 78 77 C88 64 88 45 79 35 C70 25 56 27 50 37 Z"
            fill="white"
          />
          <path d="M52.5 23 C55 13 67 7 75 11 C73 21 62.5 27 52.5 23 Z" fill="white" />
        </g>
      </g>
      <text x="128" y="86" fontSize="72" fontWeight="650" letterSpacing="-1.8" fill={inkFill}>
        MMI
        <tspan fill={practiceFill}>Practice</tspan>
        <tspan fontSize="54" fontWeight="400" fill={orgFill}>
          .org
        </tspan>
      </text>
    </svg>
  )
}
